import { render } from "./DeadlineEditor.vue?vue&type=template&id=58ad31be"
import script from "./DeadlineEditor.vue?vue&type=script&lang=js"
export * from "./DeadlineEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__